import React, { useCallback, useEffect, useMemo, useState } from "react";
import {
  AppBar,
  Box,
  CssBaseline,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Toolbar,
  Typography,
  Modal,
  Button,
} from "@mui/material";
import {
  Menu as MenuIcon,
  ExpandMore as ExpandMoreIcon,
  ExpandLess as ExpandLessIcon,
} from "@mui/icons-material";
import SettingsIcon from "@mui/icons-material/Settings";
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import AccountBoxOutlinedIcon from "@mui/icons-material/AccountBoxOutlined";
import CollectionsBookmarkIcon from "@mui/icons-material/CollectionsBookmark";
import LogoutIcon from "@mui/icons-material/Logout";
import { Link, useNavigate, useLocation } from "react-router-dom";
import useStore from "../../useStore";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";
import SavingsIcon from "@mui/icons-material/Savings";
import MenuBookIcon from "@mui/icons-material/MenuBook";

const drawerWidth = 300;

const Sidebar = (props) => {
  const { window } = props;
  const { permissions } = useStore();
  const navigate = useNavigate();
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);

  const [expandedSection, setExpandedSection] = useState({
    pigmyReport: false,
    loanReport: false,
    groupReport: false,
  });
  const [logoutModalOpen, setLogoutModalOpen] = useState(false);

  const toggleSubItems = (section) => {
    setExpandedSection((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleLogoutClick = () => {
    setLogoutModalOpen(true);
  };

  const handleLogoutConfirm = () => {
    setLogoutModalOpen(false);
    navigate("/");
  };

  const handleLogoutCancel = () => {
    setLogoutModalOpen(false);
  };
  // useEffect(() => {
  //   // Extract the base path (e.g., "customer" from "/customer/customerDetails")
  //   const basePath = location.pathname.split("/")[1];

  //   // Find the index of the item that matches the base path
  //   const index = userManagementItems.findIndex(
  //     (item) => item.path.split("/")[1] === basePath
  //   );

  //   // Set the selected index
  //   setSelectedIndex(index);
  // }, [location.pathname]);
  console.log(permissions);
  const isPathActive = useCallback((path) => {
    if (!path) {
      return false;
    }

    return location.pathname === path || location.pathname.startsWith(`${path}/`);
  }, [location.pathname]);

  const userManagementItems = useMemo(() => [
    { path: "/dashboard", text: "Dashboard", icon: <DashboardOutlinedIcon /> },
    {
      path: "/customer",
      text: "Customers",
      icon: <PersonOutlineOutlinedIcon />,
    },

    { path: "/agent", text: "Agents", icon: <AccountBoxOutlinedIcon /> },
    {
      path: "/pigmy-collections",
      text: "Pigmy Collections",
      icon: <SavingsIcon />,
    },
    {
      path: "/loan-collections",
      text: "Loan Collections",
      icon: <CollectionsBookmarkIcon />,
    },
    {
      path: "/group",
      text: "Group",
      icon: <CollectionsBookmarkIcon />,
    },
    {
      path: "/group-customer",
      text: "Group Customers",
      icon: <PersonOutlineOutlinedIcon />,
    },
    // {
    //   path: "/group-pigmy",
    //   text: "Group pigmy",
    //   icon: <SavingsIcon />,
    // },
    {
      text: "Pigmy Report",
      icon: <SavingsIcon />,
      isExpandable: true,
      sectionKey: "pigmyReport",
      subItems: [
        { path: "/pigmy-report", text: "Pigmy Report" },
        { path: "/pigmy-collection-report", text: "Pigmy Collection Report" },
      ],
    },
    {
      text: "Loan Report",
      icon: <CollectionsBookmarkIcon />,
      isExpandable: true,
      sectionKey: "loanReport",
      subItems: [
        { path: "/loan-report", text: "Loan Report" },
        { path: "/loan-collection-report", text: "Loan Collection Report" },
        { path: "/weekly-loan-collection-report", text: "Weekly Loan Report" },
      ],
    },
    {
      text: "Group Report",
      icon: <CollectionsBookmarkIcon />,
      isExpandable: true,
      sectionKey: "groupReport",
      subItems: [
        { path: "/group-pigmy-report", text: "Group Pigmy Report" },
        {
          path: "/group-pigmy-collection-report",
          text: "Group Pigmy Collection Report",
        },
        { path: "/group-loan-report", text: "Group Loan Report" },
        {
          path: "/group-loan-collection-report",
          text: "Group Loan Collection Report",
        },
        {
          path: "/weekly-group-loan-collection-report",
          text: "Weekly Group Loan Report",
        },
      ],
    },
    { path: "/enquires", text: "Enquires", icon: <CollectionsBookmarkIcon /> },
    {
      path: "/pigmy-requests",
      text: "Pigmy Requests",
      icon: <SavingsIcon />,
    },
    {
      path: "/pigmy-withdraw-requests",
      text: "Pigmy Withdraw Requests",
      icon: <SavingsIcon />,
    },
    {
      path: "/permissions",
      text: "Permissions",
      icon: <WorkspacePremiumIcon />,
    },
    {
      path: "/accounts",
      text: "Accounts",
      icon: <MenuBookIcon />,
    },
    {
      path: "/settings",
      text: "Settings",
      icon: <SettingsIcon />,
    },
  ], []);

  const filteredItems = useMemo(
    () =>
      userManagementItems
        .map((item) => {
          if (!item.subItems) {
            // No subitems, check permission directly
            if (permissions && permissions.length > 0) {
              const permission = permissions.find(
                (perm) => perm.path === item.path && perm.access
              );
              return permission ? item : null;
            }

            return null;
          } else {
            // Has subitems, filter subitems based on permissions
            const filteredSubItems = item.subItems
              .map((subItem) => {
                if (permissions && permissions.length > 0) {
                  const permission = permissions.find(
                    (perm) => perm.path === subItem.path && perm.access
                  );
                  return permission ? subItem : null;
                }

                return null;
              })
              .filter(Boolean);

            if (filteredSubItems.length > 0) {
              return { ...item, subItems: filteredSubItems };
            }
            // return null; // If no subitems are visible, hide the main item as well
            return null;
          }
        })
        .filter(Boolean),
    [permissions, userManagementItems]
  );

  useEffect(() => {
    setExpandedSection((prev) => {
      const next = { ...prev };

      filteredItems.forEach((item) => {
        if (
          item.subItems?.some((subItem) => isPathActive(subItem.path)) &&
          item.sectionKey
        ) {
          next[item.sectionKey] = true;
        }
      });

      return next;
    });
  }, [filteredItems, isPathActive]);

  const drawer = (
    <div
      style={{
        backgroundColor: "#fff",
        height: "100%",
        backdropFilter: "blur(10px)",
      }}
    >
      <Typography
        variant="h4"
        sx={{
          position: "sticky",
          top: 5,
          color: "#000",
          mt: "20px",
          textAlign: "center",
          letterSpacing: 1,
        }}
      >
        <span style={{ color: "#5252ff" }}> HP</span> FINANCE
      </Typography>
      <Box
        mt={1}
        sx={{ display: "flex", flexDirection: "column", height: "100%" }}
      >
        <List sx={{ m: "25px 28px" }}>
          {filteredItems.map((item) => {
            const isActive =
              isPathActive(item.path) ||
              item.subItems?.some((subItem) => isPathActive(subItem.path));

            return (
            <React.Fragment key={item.text}>
              <ListItem
                sx={{
                  m: 0.5,
                  p: "2px 10px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  backgroundColor: isActive ? "#5252ff" : undefined,
                  color: isActive ? "#fff" : undefined,
                  borderRadius: 2,
                  cursor: "pointer",
                }}
                onClick={() =>
                  item.isExpandable
                    ? toggleSubItems(item.sectionKey)
                    : navigate(item.path)
                }
              >
                <Link
                  to={item.path || "#"}
                  style={{
                    textDecoration: "none",
                    color: "inherit",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <ListItemIcon
                      sx={{
                        color: isActive ? "#eee" : "#494949",
                        mr: -2,
                      }}
                    >
                      {item.icon}
                    </ListItemIcon>
                    <ListItemText
                      primary={item.text}
                      sx={{
                        whiteSpace: "nowrap",
                        fontWeight: "300 !important",
                        color: isActive ? "#eee" : "#494949",
                      }}
                    />
                  </Box>
                </Link>
                {item.isExpandable ? (
                  expandedSection[item.sectionKey] ? (
                    <ExpandLessIcon sx={{ color: "#494949" }} />
                  ) : (
                    <ExpandMoreIcon sx={{ color: "#494949" }} />
                  )
                ) : null}
              </ListItem>
              {item.subItems && expandedSection[item.sectionKey] && (
                <List>
                  {item.subItems.map((subItem) => {
                    const isSubItemActive = isPathActive(subItem.path);

                    return (
                    <ListItem
                      key={subItem.text}
                      sx={{
                        pl: 4,
                        borderRadius: 2,
                        backgroundColor: isSubItemActive
                          ? "#eeeeff"
                          : undefined,
                        color: isSubItemActive ? "#5252ff" : "inherit",
                      }}
                    >
                      <Link
                        to={subItem.path}
                        style={{ textDecoration: "none", color: "inherit" }}
                      >
                        <ListItemText primary={subItem.text} />
                      </Link>
                    </ListItem>
                  )})}
                </List>
              )}
            </React.Fragment>
          )})}
        </List>
        <Box sx={{ flexGrow: 1 }} />
        <ListItem
          button
          onClick={handleLogoutClick}
          sx={{
            position: "sticky",
            bottom: 15,
            backgroundColor: "#e53935",
            color: "#fff",
            borderRadius: 2,
            ml: 5,
            p: "2px 10px",
            display: "flex",
            justifyContent: "center",
            width: "75%",
            "&:hover": {
              backgroundColor: "#c62828", // Change to a darker shade of red or your desired color
              color: "#fff", // Keep the text color white
            },
          }}
        >
          <ListItemIcon sx={{ color: "#fff" }}>
            <LogoutIcon />
          </ListItemIcon>
          <ListItemText primary="Logout" />
        </ListItem>
      </Box>
      <Modal open={logoutModalOpen} onClose={handleLogoutCancel}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 300,
            bgcolor: "background.paper",
            border: "2px solid #000",
            boxShadow: 24,
            p: 4,
          }}
        >
          <Typography variant="h6" component="h2">
            Are you sure you want to logout?
          </Typography>
          <Box sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}>
            <Button
              variant="contained"
              color="error"
              onClick={handleLogoutConfirm}
            >
              Logout
            </Button>
            <Button variant="outlined" onClick={handleLogoutCancel}>
              Cancel
            </Button>
          </Box>
        </Box>
      </Modal>
    </div>
  );

  const container =
    window !== undefined ? () => window().document.body : undefined;

  return (
    <Box sx={{ display: "flex", pr: 3 }}>
      <CssBaseline />
      <AppBar
        position="fixed"
        sx={{
          zIndex: (theme) => theme.zIndex.drawer - 1,
          backgroundColor: "#FFFFFF",
          p: 0.5,
        }}
      >
        <Toolbar>
          <IconButton
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
          >
            <MenuIcon sx={{ fontSize: 32, color: "#000" }} />
          </IconButton>
        </Toolbar>
      </AppBar>
      <Box
        component="nav"
        sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
        aria-label="mailbox folders"
      >
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true,
          }}
          sx={{
            display: { xs: "block", sm: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
              backgroundColor: "#FFFFFF",
            },
          }}
        >
          {drawer}
        </Drawer>
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: "none", sm: "block" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
              backgroundColor: "#FFFFFF",
            },
          }}
          open
        >
          {drawer}
        </Drawer>
      </Box>
    </Box>
  );
};

export default Sidebar;
